import React from 'react';
import { Image, Transformation } from 'cloudinary-react';
import { number, string, oneOfType, oneOf } from 'prop-types';

const CloudinaryImageWrapper = ({ width, height, publicId, alt }) => (
  <Image
    cloudName="fabfitfun"
    secure="true"
    width={width}
    height={height}
    publicId={publicId}
    alt={alt}
    loading="lazy"
  >
    <Transformation width={width} height={height} dpr="2.0" crop="scale" />
    <Transformation fetchFormat="auto" />
    <Transformation quality="auto" />
  </Image>
);

CloudinaryImageWrapper.propTypes = {
  width: oneOfType([number, oneOf(['auto'])]).isRequired,
  height: number.isRequired,
  publicId: string.isRequired,
  alt: string.isRequired,
};

export default CloudinaryImageWrapper;
